import { Link, useNavigate } from "react-router-dom"
import { BsFillTrashFill, BsEye } from "react-icons/bs"
import SkeletonLoader from "../SkeletonLoader"
import "./responsive-table.css"

const defaultDeleteAction = (item) => {
  //console.log(item);
}

function ResponsiveTable({
  id,
  headers,
  body,
  data,
  skip,
  link,
  needOptions = false,
  hasOwnLink = false,
  deleteAction = defaultDeleteAction,
  editLink = null,
  showViewIcon = false,
  isLoading = false,
}) {
  const navigate = useNavigate()
  const renderDesktopTable = () => (
    <div className="table-container">
      <table id={id} className="modern-table">
        <thead>
          <tr>
            <th className="col-numero">#</th>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
            {needOptions && <th className="col-actions">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              className="table-row"
              onClick={() => {
                // Prioridad: item.editLink > hasOwnLink > editLink > link
                if (item.editLink) {
                  navigate(`${item.editLink}`)
                } else if (hasOwnLink && item.link) {
                  navigate(`${item.link}`)
                } else if (editLink) {
                  navigate(`${editLink}${item._id}/editar`)
                } else if (link) {
                  navigate(`${link}${item._id}`)
                }
              }}
              style={{
                cursor:
                  item.editLink || (hasOwnLink && item.link) || editLink || link
                    ? "pointer"
                    : "default",
              }}
            >
              <td className="col-numero">
                <span className="row-number">{index + 1 + skip}</span>
              </td>
              {body.map((bodyItem, bodyIndex) => (
                <td
                  key={`${index}${bodyIndex}`}
                  className={`table-cell ${
                    item.alertClass && item.alertItem === bodyItem.data
                      ? "pending-item"
                      : ""
                  }`}
                >
                  <span className={bodyItem.classname}>
                    {item[bodyItem.data]}
                  </span>
                </td>
              ))}
              {needOptions && (
                <td className="col-actions">
                  {showViewIcon && (item.link || link) && (
                    <Link
                      to={item.link ? item.link : `${link}${item._id}`}
                      className="btn-view"
                      title="Ver solicitud"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <BsEye />
                    </Link>
                  )}
                  <button
                    onClick={(e) => {
                      e.stopPropagation()
                      deleteAction(item)
                    }}
                    className="btn-delete"
                    title="Eliminar"
                  >
                    <BsFillTrashFill />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  const renderMobileCards = () => (
    <div className="mobile-cards-container">
      {data.map((item, index) => (
        <div
          key={index}
          className="responsive-card"
          onClick={() => {
            // Prioridad: item.editLink > hasOwnLink > editLink > link
            if (item.editLink) {
              navigate(`${item.editLink}`)
            } else if (hasOwnLink && item.link) {
              navigate(`${item.link}`)
            } else if (editLink) {
              navigate(`${editLink}${item._id}/editar`)
            } else if (link) {
              navigate(`${link}${item._id}`)
            }
          }}
          style={{
            cursor:
              item.editLink || (hasOwnLink && item.link) || editLink || link
                ? "pointer"
                : "default",
          }}
        >
          <div className="card-header">
            <span className="card-number">#{index + 1 + skip}</span>
            {item.status && (
              <span className={`status-badge ${item.status?.toLowerCase()}`}>
                {item.status}
              </span>
            )}
          </div>

          <div className="card-body">
            {body.map((bodyItem, bodyIndex) => (
              <div key={bodyIndex} className="card-row">
                <span className="card-label">{headers[bodyIndex]}</span>
                <span className="card-value">
                  <span
                    className={
                      item.alertClass && item.alertItem === bodyItem.data
                        ? "pending-item"
                        : ""
                    }
                  >
                    {item[bodyItem.data]}
                  </span>
                </span>
              </div>
            ))}
          </div>

          {needOptions && (
            <div className="card-actions">
              {showViewIcon && (item.link || link) && (
                <Link
                  to={item.link ? item.link : `${link}${item._id}`}
                  className="action-btn view-btn"
                  title="Ver solicitud"
                  onClick={(e) => e.stopPropagation()}
                >
                  <BsEye /> Ver
                </Link>
              )}
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  deleteAction(item)
                }}
                className="action-btn delete-btn"
                title="Eliminar"
              >
                <BsFillTrashFill /> Eliminar
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  )

  return (
    <>
      {isLoading ? (
        <SkeletonLoader
          rowCount={5}
          columnCount={body.length}
          hasActions={needOptions}
        />
      ) : data.length === 0 ? (
        <div className="empty-state">
          <p>Sin registros</p>
        </div>
      ) : (
        <>
          <div className="desktop-view">{renderDesktopTable()}</div>
          <div className="mobile-view">{renderMobileCards()}</div>
        </>
      )}
    </>
  )
}

export default ResponsiveTable
